import React from "react";
import "./DeltaCard.scss";

interface IProps {
  item: any;
  isRemitted: boolean;
  checked: boolean;
  showRemesar: boolean;
  onRemit: (id: string) => void;
  onEdit: (id: string) => void;
}

const DeltaCardSinBaja: React.FC<IProps> = ({
  item,
  isRemitted,
  checked,
  showRemesar,
  onRemit,
  onEdit,
}) => (
  <div className={`delta-result-card${item.Remesado ? " delta-result-card--remesado" : " delta-result-card--no-remesado"}`}>
    <div className="delta-result-card__header">
      <span className="delta-result-card__nombre">{item.Nombre}</span>
      <div className="delta-result-card__status-pills">
        <span
          className={`delta-result-card__status-pill ${item.Validacion ? "delta-result-card__status-pill--ok" : "delta-result-card__status-pill--ko"}`}
          title={item.Validacion ? "Validado" : "Sin validar"}
        >
          {item.Validacion ? "Validado" : "Sin validar"}
        </span>
        <span
          className={`delta-result-card__status-pill ${item.Remesado ? "delta-result-card__status-pill--ok" : "delta-result-card__status-pill--ko"}`}
          title={item.Remesado ? "Remesado" : "Sin remesar"}
        >
          {item.Remesado ? "Remesado" : "Sin remesar"}
        </span>
      </div>
    </div>

    <div className="delta-result-card__body">
      <div className="delta-result-card__row-double">
        <div className="delta-result-card__field">
          <span className="delta-result-card__label">Año</span>
          <span className="delta-result-card__value">{item.Anyo}</span>
        </div>
        <div className="delta-result-card__field">
          <span className="delta-result-card__label">Mes</span>
          <span className="delta-result-card__value">{item.formated_month}</span>
        </div>
      </div>
      {item.NumeroReferencia && (
        <div className="delta-result-card__field">
          <span className="delta-result-card__label">Referencia</span>
          <span className="delta-result-card__value">{item.NumeroReferencia}</span>
        </div>
      )}
    </div>

    <div className="delta-result-card__footer">
      {showRemesar && (
        <label
          className={`delta-result-card__remesar-label${
            !item.Validacion ? " delta-result-card__remesar-label--disabled" : ""
          }`}
        >
          <input
            type="checkbox"
            checked={checked}
            onChange={() => onRemit(item.Id)}
            disabled={!item.Validacion}
          />
          <span>Remesar</span>
        </label>
      )}
      <button className="delta-result-card__action-btn" onClick={() => onEdit(item.Id)}>
        <span className="edit-delta-icon" />
        {isRemitted ? "Ver" : "Editar"}
      </button>
    </div>
  </div>
);

export default React.memo(DeltaCardSinBaja);
